export default __webpack_public_path__ + "static/media/IconDesc_SpelevatorPart_5.256.2afa6036.png";